<template>

    <v-dialog max-width="1000" v-model="dialog">
        <utils-popup-input-text ref="utils-popup-input-text"></utils-popup-input-text>
        <v-card class="pt-3 pb-3">

            <v-card class="d-flex align-center justify-center ml-5 mr-5" elevation="0" outlined height="50">
                <v-card class="pl-4 d-flex align-center justify-center blue--text" elevation="0">
                    {{model ? model.key : ""}}
                </v-card>
                <v-btn icon class="ma-2" color="blue" @click="onEditKey()" outlined small>
                    <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn class="ml-5 white--text" color="green" @click="onAddPage" elevation="0" small>
                    add page <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card>

            <v-card class="d-flex align-center justify-center ml-5 mr-5 mt-3" elevation="0" outlined>
                <v-carousel v-if="this.model" :show-arrows="false" v-show="this.model" hide-delimiter-background color="red" light height="735">

                    <v-carousel-item v-for="(page,i) in this.model.pages" :key="i">

                        <v-card elevation="0" outlined height="50" class="ma-3 pa-3 d-flex align-center justify-center">

                            <v-spacer></v-spacer>
                            <v-btn :disabled="model.pages.length <= 1" class="ml-3 white--text" color="red" @click="onDeletePage(i)" elevation="0" small>
                                delete page <v-icon class="ml-2" small>mdi-delete</v-icon>
                            </v-btn>
                        </v-card>

                        <v-card elevation="0" outlined height="70" class="ma-3 d-flex align-center justify-center">
                            <v-text-field
                                    class="pl-2 pr-2 pt-5"
                                    v-model="model.custom_title"
                                    :placeholder="getTitle(i)"
                            ></v-text-field>
                        </v-card>

                        <v-card elevation="0" outlined class="ma-3 pt-3 pb-3 d-flex align-center justify-center">
                            <v-card v-for="(image,j) in page.images" :key="j" class="d-flex align-center justify-center mr-3 ml-3" width="100%" elevation="0" >

                                <v-col>

                                    <v-row width="100%">
                                        <v-card elevation="0" width="100%" height="40" class="d-flex align-center justify-center pl-2 pr-2">
                                            <v-text-field
                                                    class="ml-1 mr-1"
                                                    v-model="image.id"
                                                    placeholder="image id"
                                                    required
                                            ></v-text-field>
                                        </v-card>
                                    </v-row>

                                    <v-row width="100%">
                                        <v-card elevation="0" width="100%" height="200" class="d-flex align-center justify-center mt-2" outlined>
                                            <v-progress-circular v-if="image.id && image.id.length == 0" indeterminate color="blue" class="ma-2"></v-progress-circular>
                                            <v-img v-else max-width="200" :src="getUrl(getFullPath(image.id))" class="d-flex align-center justify-center"></v-img>
                                        </v-card>

                                    </v-row>

                                    <v-row>
                                        <v-card elevation="0" width="100%" height="50" class="d-flex align-center justify-center">
                                            <v-text-field
                                                    class="ml-1 mr-3"
                                                    v-model="image.custom_message"
                                                    :placeholder="getMessage(i, j)"
                                                    required
                                            ></v-text-field>
                                            <v-checkbox
                                                    class="ml-0 mr-0"
                                                    v-model="image.highlighted"
                                            ></v-checkbox>
                                        </v-card>

                                    </v-row>

                                </v-col>

                            </v-card>
                        </v-card>

                        <v-card class="d-flex align-center justify-center ml-3 mr-3 mt-0" elevation="0">
                            <v-select
                                    dense
                                    outlined
                                    v-model="model.addon.type"
                                    :items="addons"
                                    item-text="name"
                                    hide-details
                                    return-object
                            ></v-select>
                        </v-card>

                        <v-card class="d-flex align-center justify-center ml-3 mr-3 mt-2" elevation="0" outlined height="130">
                            <v-card class="d-flex align-center justify-center ml-3 mr-3 mt-2" elevation="0" height="50" v-if="isAddonCellection(model.addon.type)">
                                <v-row width="100%">
                                    <v-card-actions v-for="row in 6" :key="row" class="ma-0 pa-0">
                                        <v-col><v-card class="d-flex align-center justify-center ma-0 pa-0" elevation="0" outlined height="50" width="50">{{row - 1}}</v-card></v-col>
                                        <v-col v-if="row != 6"><v-icon dense>mdi-arrow-right-thick</v-icon></v-col>
                                    </v-card-actions>
                                </v-row>
                            </v-card>
                            <v-card class="d-flex align-center justify-center ml-3 mr-3 mt-2" elevation="0" height="50" v-else-if="isAddonMessage(model.addon.type)">
                                {{getAddonMessage(i)}}
                            </v-card>
                            <v-card class="d-flex align-center justify-center ml-3 mr-3 mt-2" elevation="0" height="50" v-else>
                                No addon
                            </v-card>
                        </v-card>

                    </v-carousel-item>


                </v-carousel>



            </v-card>



        </v-card>
    </v-dialog>
</template>

<script>

import firebase from "firebase";
import UtilsPopupInputText from "@/modules/muiutils/popups/utils-popup-input-text";
import {ExplainerPageModel} from "@/modules/muiutils/models/explainers/ExplainerPageModel";
import {ExplainerPageImageModel} from "@/modules/muiutils/models/explainers/ExplainerPageImageModel";
import {ExplainerAddonModelType} from "@/modules/muiutils/models/explainers/ExplainerAddonModelType";

export default {
    name: "utils-explainers-pop-edit",
    props: {},
    components: {UtilsPopupInputText},
    data: () => ({
        loading: {},
        dialog: false,
        onComplete:null,
        model: {},
        imagesUrls: {},
    }),
    computed: {
        addons(){
            return ExplainerAddonModelType.getValues()
        }
    },
    methods: {
        isAddonCellection(type){
            return type == ExplainerAddonModelType.COLLECTION
        },
        isAddonMessage(type){
            return type == ExplainerAddonModelType.MESSAGE
        },
        getTitle(index){
            let custom_title = this.model.custom_title || "";
            return "pop_complex_explainer_title#{}#{}" +", "+ (custom_title.length == 0 ? this.model.key : custom_title) +", "+ index
        },
        getAddonMessage(index){
            return "pop_complex_explainer_message#{}#{}" +", "+ this.model.key +", "+ index
        },
        onEditKey(){
            var self = this;
            this.$refs['utils-popup-input-text'].show("",function (key) {
                if (key.length == 0){
                    self.$notify({title: 'Empty text!', type: "error"});
                    return;
                }
                self.model.key = key;
            })
        },
        onAddPage(){
            let data = new ExplainerPageModel([
                new ExplainerPageImageModel(), new ExplainerPageImageModel(), new ExplainerPageImageModel()
            ]);
            this.model.pages.push(data);
            this.$forceUpdate();
        },
        onDeletePage(page){
            let self = this;
            this.$confirm("Are you sure?").then(() => {
                self.model.pages.splice(page, 1);
                console.log(self.model)
            }).catch(() => {})
        },
        getMessage(page, image){
            let custom_message = this.model.pages[page].images[image].custom_message || "";
            let id = this.model.pages[page].images[image].id || "";
            return "exp_card_{}" +", "+ (custom_message.length == 0 ? id : custom_message)
        },
        show(model, onComplete) {

            console.log(model)

            this.model = model
            this.dialog = true
            this.onComplete = onComplete

            if (this.model.pages == undefined){
                this.model.pages = [];
                this.onAddPage();
            }
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.onPressSave();
            this.hide()
        },
        onPressSave() {
            if (this.model == null || this.model == undefined){
                return;
            }
            this.dialog = false
            this.onComplete(this.model)
        },
        getFullPath(imageId){
            return 'explainers/'+imageId+'.png'
        },
        getUrl(url){

            if (this.imagesUrls[url] != undefined){
                return this.imagesUrls[url];
            }

            let self = this;

            firebase.storage()
            .ref(url)
            .getDownloadURL().then((urlOut) => {
            self.imagesUrls[url] = urlOut;
            self.$forceUpdate();
            }).catch(() => {
                // self.imagesUrls[url] = require("@/modules/muiutils/resources/no-image-icon.png");
                // self.$forceUpdate();
            });

        },
    },
}
</script>

<style scoped>

</style>